import { PlessJsonResponderSub } from 'src/app/commons/kymw00/pless-json-responder-sub.service';
import { KYMW1202Model } from '../kymw1202.model';
import { Injectable } from '@angular/core';
import { PlessHttp } from '../../../../shared/http/pless-http.service';
import { PlessDialogServiceSub } from '../../../../commons/kymw00/pless-dialog-service-sub';
import { PlessRequest } from 'src/app/shared/vo/pless-request.model';
import { ExecutePrintCompanyDataThumbnailService } from 'src/app/kymw/kymw23/kymw2300/api-services/execute-print-company-data-thumbnail.service';

/**
 * 掲載媒体設定更新サービス
 * @export UpdatePublishMediumSetting
 * @class UpdatePublishMediumSetting
 * @extends {PlessJsonResponderSub}
 */
@Injectable()
export class UpdatePublishMediumSetting extends PlessJsonResponderSub<null> {
  private model: KYMW1202Model;
  private calbak: () => void;

  constructor(
    protected plessHttp: PlessHttp,
    protected dialogService: PlessDialogServiceSub
  ) {
    super(plessHttp, dialogService);
  }

  /**
   * bodyにセットする値を返す
   *
   * @private
   * @returns {PlessRequest} リクエストJSON
   * @memberof UpdatePublishMediumSetting
   */
  private getBody(): PlessRequest {
    return new PlessRequest({
      update: {
        PublishMediumSetting: {
          condition: {
            PCode: this.model.pCode,
          },
          combination: this.model.list
            .filter(_ => _.check)
            .map(_ => ({ parameter: { MediumType: _.mediumType } })),
        }
      }
    });
  }

  /**
   * API呼び出し
   *
   * @param model
   * @memberof UpdatePublishMediumSetting
   */
  execute(model: KYMW1202Model, f: () => void = null): void {
    this.model = model;
    this.calbak = f;
    this.send('updatePublishMediumSetting', this.getBody());
  }

  /**
   * API通信成功時の処理
   *
   * @param {*} data レスポンスデータ
   * @memberof UpdatePublishMediumSetting
   */
  success() {
    if (this.calbak) this.calbak();
  }

}
